module.exports = __webpack_public_path__ + "img/logo.8a1e2a1d.svg";